import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  groupIds: yup.array().of(yup.number()).required(),
});

export function useUnmarkNoDupPatientsMutation(options = {}) {
  return useMutation((dto) => {
    const req = requestSchema.validateSync(dto, {
      strict: true,
    });
    return http.post(HTTP_ENDPOINTS.postUnmarkNoDupPatients(), {
      group_ids: req.groupIds,
    });
  }, options);
}
